<div class="ai-button-chatbot-wrapper" stopPropagation>
    <app-button-ai-chatbot (buttonClick)="buttonClick($event)"></app-button-ai-chatbot>
</div>

<div class="ai-popup-chatbot-wrapper" #popupWrapper clickOutside (onClickOutside)="onClickOutsidePopup($event)">
    <app-popup-ai-chatbot (closeEmit)="closeEmit($event)"></app-popup-ai-chatbot>
</div>